// Lab77 — B2B + Marketplace JS
// Scroll reveal animations + homepage header reveal
(function () {
  'use strict';

  // ── Scroll reveal (IntersectionObserver) ─────────────────────────────
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function initReveal() {
    document
      .querySelectorAll('.lab77-reveal, .lab77-reveal-left, .lab77-reveal-right, .lab77-reveal-scale')
      .forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

})();
